import { useQuery } from '@tanstack/react-query';
import type { CampaignStep, CursorPage } from '@seo/types';
import { apiGet } from '@/lib/api';

export function useCampaignSteps(campaignId: string) {
  return useQuery({
    queryKey: ['campaign-steps', campaignId],
    queryFn: () => apiGet<CursorPage<CampaignStep>>(`/v1/campaigns/${campaignId}/steps`),
    enabled: Boolean(campaignId),
    refetchInterval: 5000,
  });
}
